'use client';

import { useUser } from '@/components/user/user-provider';
import { AnalyticsUserIdentity } from './analytics-user-identity';

/**
 * Reads the user from UserProvider and sends identification to GA.
 * Must be used inside <UserProvider>.
 */
export function AnalyticsUserTracker() {
  const { user } = useUser();

  if (!user || 'error' in user) return null;

  return (
    <AnalyticsUserIdentity
      user={{
        id: user.id,
        email: user.email,
        name: user.name,
        is_coach: user.is_coach,
      }}
    />
  );
}
